import React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { fmtMoney, fmtInt } from '../lib/pivot';
import { yearColour, yearNum } from '../lib/periods';

/**
 * One line per year, x-axis = period index within the year (Jan…Dec, Q1…Q4,
 * W1…W53). Used full-size for the YoY master and small for the channel
 * small-multiples. Years overlay so seasonality / growth is read at a glance.
 *
 * Props: { years, indices, idxLabel, valueAt(year, idx), money, height, hideLegend }
 */
export default function YearOverlayChart({ years, indices, idxLabel, valueAt, money = false, height = 360, hideLegend = false, latestYear }) {
  const xLabels = indices.map(idxLabel);
  const fmt = money ? fmtMoney : fmtInt;
  // Colour is keyed to the overall latest year (passed in) so toggling years off
  // never repaints a prior year black. yearNum handles "2024" and "2024/25".
  const maxYear = latestYear != null ? yearNum(latestYear) : Math.max(...years.map(yearNum));
  const series = years.map((y) => ({
    label: y,
    data: indices.map((i) => valueAt(y, i)),
    color: yearColour(y, maxYear),
    showMark: false,
    curve: 'monotoneX',
    valueFormatter: (v) => (v == null ? '' : fmt(v)),
  }));
  return (
    <LineChart
      height={height}
      xAxis={[{ scaleType: 'point', data: xLabels }]}
      yAxis={[{ valueFormatter: (v) => fmt(v) }]}
      series={series}
      hideLegend={hideLegend}
      margin={{ left: 64, right: 16, top: 16, bottom: 24 }}
    />
  );
}
